import { render } from "./ImagesView.vue?vue&type=template&id=1cfa365f&ts=true"
import script from "./ImagesView.vue?vue&type=script&lang=ts"
export * from "./ImagesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__